function clickFiltersSubmit() {
  var submit = document.getElementById('filters-submit-js');
  if (submit) submit.click();
}

function applySorting(order) {
  var formInput = document.getElementById('sort-by-input-js');
  if (formInput) formInput.value = order;

  clickFiltersSubmit();
}

document.addEventListener('change', function(event) {
  if (event.target.matches('#sort-by-js, .sort-by-mobile-js')) {
    applySorting(event.target.value);
  }
});
